import { Component, OnInit, Signal } from '@angular/core';
import { GlobalElementsService } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/services/global-elements.service';
import { IGlobalElements } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/tenant/interfaces/global-elements.interface';
import { ITitleSectionInformation } from '../../interfaces/title-section-information.interface';

@Component({
  standalone: false,
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent implements OnInit {
  titleSectionInformation: ITitleSectionInformation = {
    title: 'Privacy policy',
    description: 'The fine print.',
  };

  globalElements: Signal<IGlobalElements>;

  constructor(private readonly globalEmentsService: GlobalElementsService) {}

  ngOnInit() {
    this.globalElements = this.globalEmentsService.globalElements;
  }
}
